import { useEffect } from 'react';

const useBeforeUnloadPrompt = (isEnabled, message) => {
  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    const onBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = message;

      return message;
    };

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [isEnabled, message]);
};

export default useBeforeUnloadPrompt;
